/**
 * 阴影展示大小
 */
export const SHADOW_SIZE = 0.25;

//ppt和海报效果不一致  所以需要调整比例
export const SCALE_WIDTH_RATIO = 2;
export const SCALE_HEIGHT_RATIO = 1.7;
export const SCALE_RATIO = 3;

/**
 * 浏览器 Canvas 最大面积限制（像素数），留一定安全余量
 * Chrome/Firefox 通常为 16384² ≈ 268M，这里使用 256M 作为安全上限
 */
export const MAX_CANVAS_AREA = 256 * 1024 * 1024;

/**
 * 浏览器 Canvas 单边最大像素数
 * 超过此值后 Canvas 虽能创建但 drawImage 等绑定操作会静默失败，输出空白内容
 */
export const MAX_CANVAS_DIMENSION = 16384;
